<template>
  <div>
    <el-container class="login">
      <el-header class=".header" height="auto" style="padding:0px">
        <!-- <Header :headerState="true" /> -->
      </el-header>
      <el-main style="padding:0px">
        <!-- <Nuxt /> -->
        <!-- <Backtop /> -->
      </el-main>
      <el-footer style="padding:0;">
        <div class="footer">
          <div class="footer_left">
            <div class="footer_site">
              <span><i class="icon_email"></i>zkfylszh@163.com</span>
              <span><i class="icon_phone"></i>18383029021</span>
              <span><i class="icon_site"></i>西藏自治区山南市乃东区泽当街道产城一体产业园区标准化厂房10号</span>
            </div>
            <div class="footer_records">
              <p>西藏蓝萨智汇科技有限公司</p>
              <p><a href="https://beian.miit.gov.cn/" target="_blank">藏ICP备2025003028号-1</a></p>
              <!-- <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备18045685号-4</a> -->
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import Header from '../components/Header'
export default {
  // 组件参数
  props: {},
  // JS片段
  mixins: [],
  // 局部注册的组件
  components: {
    //  Header
  },
  // 组件状态值
  data () {
    return {};
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  // 预请求数据
  created () { },
  // 组件方法
  mounted () { },
};
</script>

<style scoped lang='scss'>
.footer {
  height: 248px;
  width: 100%;
  text-align: center;
  background: #1e252f;
  display: flex;
  justify-content: center;
  align-items: center;
  .footer_left {
    width: 42%;
    min-width: 610px;
    margin-right: 114px;
    .footer_site {
      font-size: 12px;
      font-weight: normal;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #393d40;
      padding: 0px 5px 10px;
      margin-bottom: 20px;
      .icon_email {
        display: inline-block;
        width: 16px;
        height: 11px;
        background: url("@/assets/imgs/home/youxiang-icon.png") center no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
      .icon_phone {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url("@/assets/imgs/home/lianxifangshi-icon.png") center
          no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
      .icon_site {
        display: inline-block;
        width: 11px;
        height: 17px;
        background: url("@/assets/imgs/home/dizhi -icon.png") center no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
    }
    .footer_records {
      font-size: 14px;
      color: #ccc;

      a {
        color: #ccc;
      }
      a:hover {
        color: #0a7deb;
      }
    }
  }
  .footer_right {
    .footer_right_tit {
      text-align: left;
      font-size: 18px;

      color: #ffffff;
    }
    .footer_code {
      img {
        width: 129px;
        height: 127px;
        border: 1px solid #fff;
      }
      .footer_code_item {
        float: left;
        margin-top: 14px;
        margin-right: 14px;
        font-size: 14px;

        color: #80848a;
      }
    }
  }
}
</style>
